<template>
  <!-- A brand's ad history starting today: nothing before it, the first bar today, more to come -->
  <div class="relative flex-shrink-0 select-none" style="width: 240px; height: 108px;">
    <svg xmlns="http://www.w3.org/2000/svg" width="240" height="108" viewBox="0 0 240 108" fill="none"
    class="absolute top-0 left-0">
      <!-- No history -->
      <path transform="translate(13.2 85.2)" d="M0.8 0.8H0.85M82.8 0.8H82.75M4.85 0.8H4.95M8.95 0.8H9.05M13.05 0.8H13.15M17.15 0.8H17.25M21.25 0.8H21.35M25.35 0.8H25.45M29.45 0.8H29.55M33.55 0.8H33.65M37.65 0.8H37.75M41.75 0.8H41.85M45.85 0.8H45.95M49.95 0.8H50.05M54.05 0.8H54.15M58.15 0.8H58.25M62.25 0.8H62.35M66.35 0.8H66.45M70.45 0.8H70.55M74.55 0.8H74.65M78.65 0.8H78.75"
      stroke="#CDD1D7" stroke-width="1.6" stroke-linecap="round"/>
      <!-- Baseline from today on -->
      <path d="M106 86H226" stroke="#E6E8EB"/>
      <!-- Bars still to come -->
      <rect x="136" y="56" width="14" height="30" rx="4" fill="#F0F1F3"/>
      <rect x="158" y="60" width="14" height="26" rx="4" fill="#F0F1F3"/>
      <rect x="180" y="46" width="14" height="40" rx="4" fill="#F0F1F3"/>
      <rect x="202" y="34" width="14" height="52" rx="4" fill="#F0F1F3"/>
      <!-- Today -->
      <rect x="84" y="6" width="44" height="18" rx="9" fill="#FDF2F1"/>
      <path d="M106 26V86" stroke="#ED615A" stroke-width="1.25"/>
      <rect x="114" y="62" width="14" height="24" rx="4" fill="#ED615A"/>
      <circle cx="106" cy="86" r="3.5" fill="#ED615A" stroke="white" stroke-width="1.5"/>
    </svg>
    <div class="illustration-label absolute font-normal" style="left: 33px; top: 69px; width: 44px; color: #A4A8B0;">
      No history
    </div>
    <div class="illustration-label absolute font-bold" style="left: 92.5px; top: 9.4px; width: 27px; color: #AB2D27;">
      Today
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrackBrandIllustration'
}
</script>

<style scoped>
.illustration-label {
  font-size: 9px;
  line-height: 11px;
  text-align: center;
  white-space: nowrap;
}
</style>
